import { Component, Vue, Watch } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, TranslationModel, ProductModel } from "../models/product";
import { QuantityCalculationResultModel } from "../models/QuanityCalculatorCast";

@Component
export default class ConsumptionCalculator extends Vue {
    protected area: number = NaN;
    protected layer: number = NaN;
    protected translations: TranslationModel;
    private isCalculating: boolean = false;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
        if (!this.area && Number(productStore.product.consumptionArea) && productStore.product.consumptionArea > 0) {
            this.area = productStore.product.consumptionArea;
        } else {
            this.area = Number.parseFloat(this.getSession("area"));
        }

        if (!this.layer && Number(productStore.product.consumptionLayer) && productStore.product.consumptionLayer > 0) {
            this.layer = productStore.product.consumptionLayer;
        } else {
            this.layer = Number.parseFloat(this.getSession("layer"));
        }
        this.setMeasurementsFromSessionFloor();
        this.setMeasurementsFromSessionBlock();
    }

    get product(): ProductModel {
        return productStore.product;
    }

    get variant(): Variant {
        return productStore.variant;
    }

    get quantity(): number {
        return productStore.quantity;
    }

    get itemConsumptionCalculatorBlock(): boolean {
        return productStore.variant.itemConsumptionCalculatorBlock;
    }

    get itemConsumptionCalculatorFloor(): boolean {
        return productStore.variant.itemConsumptionCalculatorBag;
    }

    get itemConsumptionCalculator(): string {
        return productStore.variant.itemConsumptionCalculator;
    }

    get itemMaterialConsumption(): number {
        return productStore.variant.itemMaterialConsumption;
    }

    @Watch("quantity")
    protected onQuantityChange(value: number, oldValue: number) {
        if (this.isCalculating) {
            return;
        }

        if (Number(this.layer)) {
            const area = Math.floor((value * this.variant.itemPrimaryPackagingWeight) / (this.layer * this.product.productMaterialConsumption));
            this.area = area;
        }

        productStore.dispatchQuantity(value);
    }

    @Watch("area")
    protected onAreaChange(value: number, oldValue: number) {
        if (Number(value) && value !== oldValue) {
            this.storeSession("area", value);
        }
        this.calculateQuantity();
    }

    @Watch("layer")
    protected onLayerChange(value: number, oldValue: number) {
        if (Number(value) && value !== oldValue) {
            this.storeSession("layer", value);
            this.calculateQuantity();
        }
    }

    private calculateQuantity() {
        if (this.variant.itemConsumptionCalculatorBlock) {
            if (!Number(this.area) || !Number(this.itemMaterialConsumption)) {
                productStore.dispatchQuantity(1);
            } else {
                const quantity = Math.ceil(this.area * this.itemMaterialConsumption);
                productStore.dispatchQuantity(quantity);
            }
        } else {
            if (!Number(this.area) || !Number(this.layer)) {
                productStore.dispatchQuantity(0);
            } else {
                const material = this.area * this.layer;
                const kgNeeded = material * this.product.productMaterialConsumption;
                const quantity = Math.ceil(kgNeeded / this.variant.itemPrimaryPackagingWeight);
                productStore.dispatchQuantity(quantity);
            }
        }
    }

    private storeSession(key: string, value: number): void {
        if (typeof(sessionStorage) !== "undefined") {
            sessionStorage.setItem(this.variant.baseProductArticleNumber + key, value.toString());
        }
    }

    private getSession(key: string): string {
        if (typeof(sessionStorage) !== "undefined") {
            return sessionStorage.getItem(this.variant.baseProductArticleNumber + key) || "";
        }

        return "";
    }

    private setMeasurementsFromSessionFloor() {
        const floorquantity = this.getSessionWithoutVariantId("floorquantityBag");
        const floorquantityPlaster = this.getSessionWithoutVariantId("floorquantityPlaster");
        if (floorquantity !== "" && this.variant.itemConsumptionCalculatorBag) {
            const quantityCalcResults = JSON.parse(floorquantity);
            if (quantityCalcResults !== undefined) {
                const currentVariantData = quantityCalcResults.filter((x: QuantityCalculationResultModel)  => x.variantId === this.variant.variantId);
                if (currentVariantData.length > 0 && Number(currentVariantData[0].sack) && currentVariantData[0].sack > 0) {
                    this.area = currentVariantData[0].yta;
                    this.layer = currentVariantData[0].layerThickness;

                    sessionStorage.setItem("floorquantityBag", "");
                    this.isCalculating = true;
                }
            }
        }
        if (floorquantityPlaster !== "" && this.variant.itemConsumptionCalculatorPlaster) {
            const quantityCalcResults = JSON.parse(floorquantityPlaster);
            if (quantityCalcResults !== undefined) {
                const currentVariantData = quantityCalcResults.filter((x: QuantityCalculationResultModel)  => x.variantId === this.variant.variantId);
                if (currentVariantData.length > 0 && Number(currentVariantData[0].sack) && currentVariantData[0].sack > 0) {
                    this.area = currentVariantData[0].yta;
                    this.layer = currentVariantData[0].layerThickness;

                    sessionStorage.setItem("floorquantityPlaster", "");
                    this.isCalculating = true;
                }
            }
        }
    }

    private setMeasurementsFromSessionBlock() {
        const blockquantity = this.getSessionWithoutVariantId("blockquantity");
        if (blockquantity !== "") {
            const quantityCalcResults = JSON.parse(blockquantity);
            if (quantityCalcResults !== undefined) {
                const currentVariantData = quantityCalcResults.filter((x: QuantityCalculationResultModel)  => x.variantId === this.variant.variantId);
                if (currentVariantData.length > 0 && Number(currentVariantData[0].sack) && currentVariantData[0].sack > 0) {
                    this.area = currentVariantData[0].yta;

                    sessionStorage.setItem("blockquantity", "");
                    this.isCalculating = true;
                }
            }
        }
    }

    private getSessionWithoutVariantId(key: string): string {
        if (typeof(sessionStorage) !== "undefined") {
            return sessionStorage.getItem(key) || "";
        }

        return "";
    }
}
